<template>
  <a-drawer
    :title="title"
    :visible="visible"
    :width="width"
    @handleCancel="handleCancel"
    @handleOk="handleOk"
    okButtonName="完成"
  >
    <div class="wrap">
      <virtual-list
        :title="leftTitle"
        :list="leftList"
        :name="leftName"
        @fetchValue="fetchLeftValue"
        :width="300"
        :height="640"
        :currentIndex="currentIndex"
      ></virtual-list>
      <a-card style="width: 100%" v-if="leftItem">
        <div>
          <a-form layout="inline">
            <a-form-item label="标题">
              <a-input
                v-model="inputQuery.contentDetail"
                placeholder="请输入"
                style="width: 150px; margin-bottom: 20px"
                enterButton
              />
            </a-form-item>
            <a-form-item style="display: flex; justify-content: flex-end">
              <a-button type="primary" style="margin: 0 10px" @click="onSearch">查询</a-button>
              <a-button type="primary" @click="reset">重置</a-button>
            </a-form-item>
          </a-form>
          <a-table
            ref="table"
            size="default"
            :filterMultiple="false"
            :rowKey="(item) => item.id"
            :columns="columns"
            :dataSource="dataList"
            :rowSelection="rowSelection"
            :pagination="pagination"
            :scroll="{ y: 400 }"
            @change="handleTableChange"
            :loading="loading"
          >
          </a-table>
        </div>
      </a-card>
    </div>
  </a-drawer>
</template>

<script>
import { STable, VirtualList, DictSelector } from '@/components'
import { mapActions } from 'vuex'

export default {
  name: 'Select',
  components: {
    STable,
    VirtualList,
    DictSelector,
  },
  props: {
    matType: {
      type: String,
      default: 'multiple',
    },
    title: {
      type: String,
      default: '选择',
    },
    width: {
      type: Number,
      default: 1300,
    },
    leftTitle: {
      type: String,
      default: '列表',
    },
    leftList: {
      type: Array,
      default: () => {
        return []
      },
    },
    leftName: {
      type: String,
      default: 'name',
    },
    leftParams: {
      type: Object,
      default: () => {
        return {}
      },
    },
    leftUrl: {
      type: String,
      default: '',
    },
    leftItem: {
      type: String,
      default: '',
    },
    // url: {
    //   type: String,
    //   default: '',
    // },
    columns: {
      type: Array,
      default: () => {
        return []
      },
    },
    dataList: {
      type: Array,
      default: () => {
        return []
      },
    },
    params: {
      type: Object,
      default: () => {
        return {
          total: 0,
          current: 1,
          pageSize: 10,
          showSizeChanger: true,
          pageSizeOptions: ['5', '10', '15', '20'],
        }
      },
    },
    // params: {
    //   type: Object,
    //   default: () => {
    //     return {}
    //   },
    // },
    // selectKeys: {
    //   type: Array,
    //   default: null
    // }
  },
  data() {
    return {
      visible: true,
      inputQuery: {
        contentDetail: '',
        subjectType: '',
        type: '',
      },

      subjectId: '',
      testPaperName: '',

      noTitleKey: 'tab1',
      currentIndex: 0,

      selectMap: {},
      loading: true,
      activityList: [],

      selectedRows: [],
      selectedActivityRows: [],
      radioSelectRows: [],
      selectKeys: [],
      list: [],
      selectTopList: [],
    }
  },
  beforeCreate() {
    this.form = this.$form.createForm(this, { name: 'time_related_controls' })
  },
  computed: {
    rowSelection() {
      return {
        type: this.matType,
        onChange: this.onChangeVal,
        selectedRowKeys: this.selectKeys,
        getCheckboxProps: (record) => ({
          props: {
            disabled: record.name === 'Disabled User',
            name: record.name,
          },
        }),
      }
    },
  },
  async created() {},
  methods: {
    ...mapActions('materiel', ['getDict']),

    async handleTableChange(pagination) {
      this.pagination.current = pagination.current
      this.pagination.pageSize = pagination.pageSize
      this.queryParam.page = pagination.current
      this.queryParam.size = pagination.pageSize
      this.$emit('handleTableChange', {
        current: pagination.current,
        pageSize: pagination.pageSize,
        page: pagination.current,
        size: pagination.pageSize,
      })
      await this.getList()
      // this.addSeletctedMap(this.dataList, this.selectTopList)
    },

    onChangeVal(selectedRowKeys, selectedRows) {
      const key = `${this.currentLeftId}_${this.pagination.current}`
      this.selectKeys = selectedRowKeys
      if (this.matType === 'radio') {
        this.radioSelectRows = []
      }
      this.selectMap[key] = selectedRows
      this.radioSelectRows = _.flatten(Object.values(this.selectMap)).concat(...this.selectTopList)
    },
    addSeletctedMap(list, selectList) {
      // 因为保存的方式是进行{1:xxx,2:xxx}
      const key = `${this.currentLeftId}_${this.pagination.current}`
      const arr = []
      if (!this.selectMap[key]) {
        list.map((v) => {
          for (let i = 0; i < selectList.length; i++) {
            if (v.id === selectList[i].id) {
              const item = selectList.splice(i, 1)
              arr.push(item[0])

              i--
            }
          }
        })
        this.selectMap[key] = arr
      }
    },
    // 显示/隐藏
    async show(editInfo) {
      this.visible = true
    },
    async fetchLeftValue(record, index) {
      this.currentLeftId = record.id
      this.currentIndex = index
      this.$emit('fetchLeftValue', record, index)
    },
    transformData({ editInfo }) {
      // 处理选中题目的内容。目前是radioSelectRows是右边选中框的内容，selectKeys是中间那个蓝色框内容。selectTopList是为了有个选中的标志进行选中map的赋值
      this.radioSelectRows = _.cloneDeep(editInfo)
      this.selectTopList = _.cloneDeep(editInfo)
      editInfo.forEach((v) => {
        this.selectKeys.push(v.id)
      })
    },
    // 提交
    handleOk() {
      // this.selectedRows = this.radioSelectRows
      this.$emit('selectValues', this.radioSelectRows, this.currentLeftId)
      this.handleCancel()
      this.$message.success('选择成功')
    },

    // 关闭
    handleCancel() {
      this.visible = false
      // 初始化
      this.queryParam.size = 10
      this.currentIndex = 0
      this.queryParam.page = 1
      this.pagination = {
        total: 0,
        current: 1,
        pageSize: 10,
        showSizeChanger: true,
        pageSizeOptions: ['5', '10', '15', '20'],
      }
      this.selectKeys = []
      this.radioSelectRows = []
      this.selectMap = {}
      this.reset()
      this.inputQuery = {
        contentDetail: '',
        subjectType: '',
        type: '',
      }
      // this.$forceUpdate()
    },
    reset() {
      this.inputQuery = {
        contentDetail: '',
        subjectType: '',
        type: '',
      }
      this.getList()
    },
    async getList() {
      this.loading = true
      //   const { contentDetail, subjectType, type } = this.inputQuery
      if (this.currentLeftId) {
        const params = {
          currentLeftId: this.currentLeftId,
          current: this.queryParam.page,
          size: this.queryParam.size,
          ...this.params,
        }
        const res = await this.$http.get(this.$global.question, { params })
        this.dataList = res.records
        this.pagination.pageSize = res.size
        this.pagination.total = res.total
        this.loading = false
        this.addSeletctedMap(this.dataList, this.selectTopList)
        this.$forceUpdate()
      }
    },

    onSearch() {
      this.queryParam.page = 1
      this.queryParam.size = 10
      this.getList()
    },
  },
}
</script>

<style lang="stylus" scoped>
.thumbnail {
  width: 50px;
  height: 50px;
}

.wrap {
  display: flex;
}

.header {
  width: 100%;
  height: 50px;
  // opacity :0.5;
  border-radius: 5px;
  margin-bottom: 10px;
}

.content {
  width: 100%;
  height: 500px;
  border: 1px solid rgb(224, 224, 224);
  border-radius: 5px;
  padding: 20px;
  overflow: auto;
}

.content-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.wrap-search {
  // width: 400px;
  border: 1px solid #edeaea;
  border-radius: 10px;
  height: 100%;
  padding: 10px 20px;
}
</style>
